import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { cx } from 'emotion';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import CircleIcon from '@material-ui/icons/Lens';
import { COLORS } from '../../../util/Colors';
import { useRootStore } from '../../../../stores/BridgeProvider';
import Spinner from '../../../util/Spinner';

const StatusBox = styled.div`
  font-size: 0.9rem;
  padding: 16px 24px;
  .issueConnectingMessage {
    font-size: 0.8rem;
    margin-bottom: 10px;
    display: block;
  }
  #statusSpan {
    display: inline-flex;
    align-items: center;
  }
  #errorIcon {
    color: ${COLORS.red};
    font-size: 1rem;
    margin-left: 3px;
  }
  #circleIcon {
    color: ${COLORS.green};
    font-size: 1rem;
    margin-left: 3px;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  inner: {
    minWidth: 400,
  },
  actions: {
    justifyContent: 'flex-end',
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1),
  },
  noActivity: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Activity = ({ className, ...rest }) => {
  const classes = useStyles();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [intInfo, setIntInfo] = useState(null);

  const getIntegrationInfo = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/organization-integration-status`,
      );
      setIntInfo(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const initialActions = async () => {
      await getIntegrationInfo();
      setLoading(false);
    };
    initialActions();
  }, []);
  if (isLoading) return <Spinner />;

  const { LastSync, IsValid } = intInfo;
  const formattedLastSync = moment
    .utc(LastSync)
    .local()
    .format('YYYY-MM-DD hh:mm A');

  return (
    <Card
      {...rest}
      className={cx(classes.root, className)}
      style={{ width: '50%' }}
    >
      <CardHeader title="Sync Status" />
      <Divider />
      <CardContent className={classes.content}>
        {intInfo && (
          <StatusBox>
            <p>Last Sync: {formattedLastSync}</p>
            <p>
              Status:{' '}
              {IsValid ? (
                <span id="statusSpan">
                  {' '}
                  Active <CircleIcon id="circleIcon" />
                </span>
              ) : (
                <span id="statusSpan">
                  Broken
                  <ErrorIcon id="errorIcon" />
                </span>
              )}
            </p>
            {!IsValid && (
              <span className="issueConnectingMessage">
                There's been an issue connecting with Xero. Please
                reauthenticate below to restore integration.{' '}
                <Link
                  to="/external-system-settings"
                  style={{ color: COLORS.blue, fontWeight: '600 ' }}
                >
                  Manage Integration
                </Link>
              </span>
            )}
          </StatusBox>
        )}
      </CardContent>
    </Card>
  );
};

export default Activity;
